/**
 * 比价详情页路径
 */
export const PRICE_COMPARE_DETAIL_PAGE_PATH = '/priceCompare/detail'
